import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import { Segmento } from '../../_models/segmento';
import { ActividadEconomica } from '../../_models/actividad-economica';
import { ActividadEconomicaService } from '../../_services/actividad-economica.service';
import { SegmentoActividad } from '../../_models/segmento-actividad';
import { forkJoin } from 'rxjs';
import { SegmentoActividadesService } from '../../_services/segmento-actividades.service';
import { NavService } from '../../_services/_nav.service';
import { TipoActividadEconomica } from '../../_enums/enum';
import {sleep} from '../../utils/utilidades';

@Component( {
  templateUrl: 'segmento-actividades.component.html',
  selector: 'app-segmento-actividades',
} )
export class SegmentoActividadesComponent implements OnInit, AfterViewInit {

  @Input() segmento: Segmento;
  actFuente: ActividadEconomica[] = [];
  actSeleccionadas: ActividadEconomica[] = [];
  segmentoActividades: SegmentoActividad[] = [];
  allActividades: ActividadEconomica[] = [];
  carInformacionInicial = true;
  guardando = false;

  tipoActividad = TipoActividadEconomica;

  constructor( private actividadEconomicaServicio: ActividadEconomicaService,
               private navServicio: NavService,
               private segmentoActividadesServicio: SegmentoActividadesService ) {
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    forkJoin( this.segmentoActividadesServicio.obtenerPorSegmento( this.segmento.idSegmento ),
      this.actividadEconomicaServicio.listarPorTipo( this.tipoActividad.CLASE) ).subscribe( async ( [ res1, res2 ] ) => {
      this.segmentoActividades = res1;
      this.allActividades = res2;
      this.loadLists();
      await sleep(1000);
      this.carInformacionInicial = false;
    } );
  }

  loadLists() {
    this.allActividades.map( ae => {
      if ( this.segmentoActividades.find( sa => sa.idActividad === ae.idActividadEconomica && sa.indicadorHabilitado ) ) {
        this.actSeleccionadas.push( ae );
      } else {
        if ( ae.indicadorHabilitado ) {
          this.actFuente.push( ae );
        }
      }
    } );
    this.actSeleccionadas = [ ...this.actSeleccionadas ];
  }

  guardar( event: ActividadEconomica[], seleccionado: boolean ) {
    this.guardando = true;
    const registros = [];
    event.map( e => {
      const a = this.segmentoActividades.findIndex( sa => sa.idActividad === e.idActividadEconomica );
      const temp: SegmentoActividad = {
        id: a >= 0 ? this.segmentoActividades[ a ].id : null,
        idSegmentoActividad: a >= 0 ? this.segmentoActividades[ a ].idSegmentoActividad : null,
        idSegmento: this.segmento.idSegmento,
        segmento: this.segmento.nombre,
        idActividad: e.idActividadEconomica,
        actividad: e.actividadEconomica,
        indicadorHabilitado: seleccionado,
        auditoriaUsuario: null,
        auditoriaFecha: null
      };
      if ( a >= 0 ) {
        this.segmentoActividades[ a ].indicadorHabilitado = seleccionado;
      } else {
        this.segmentoActividades.push( temp );
      }
      registros.push( temp );
    } );
    this.segmentoActividadesServicio.bulk( registros ).subscribe( res => {
      if ( seleccionado ) {
        res.map( ( s: SegmentoActividad ) => {
          const a = this.segmentoActividades.findIndex( x => x.idActividad == s.idActividad && !x.idSegmentoActividad );
          if ( a >= 0 ) {
            this.segmentoActividades[ a ].idSegmentoActividad = s.idSegmentoActividad;
          }
        } );
      }
      this.navServicio.setMesage( 2 );
      this.guardando = false;
    } );
  }

}
